




import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { fetchBanners, deleteBanner } from "../redux/actions/bannerActions";
import { MdDelete } from "react-icons/md";
import AddBanner from "../components/Bannner/AddBanner";
import Loader from "../components/shared/Loader";
import ConfirmDeleteModal from "../components/shared/ConfirmDeleteModal";
import toast from "react-hot-toast";

const Banners = () => {
  const dispatch = useDispatch();
  const { banners, loading, error } = useSelector((state) => state.banners);

  const [showAddBanner, setShowAddBanner] = useState(false);
  const [showConfirmDelete, setShowConfirmDelete] = useState(false);
  const [bannerToDelete, setBannerToDelete] = useState(null);

  useEffect(() => {
    dispatch(fetchBanners());
  }, [dispatch]);

  const handleDeleteBanner = async (bannerId, bannerType) => {
    try {
      await dispatch(deleteBanner(bannerId, bannerType));
      toast.success("Banner deleted successfully");
      setShowConfirmDelete(false);
    } catch (error) {
      toast.error("Failed to delete banner");
    }
  };

  if (loading) return <Loader />;

  if (error) return <div className="p-4 text-red-500 font-medium">{error}</div>;

  const bannerTypes = [
    { key: "topBanners", label: "Top Banners" },
    { key: "midBanners", label: "Mid Banners" },
    { key: "bottomBanners", label: "Bottom Banners" },
  ];

  return (
    <div className="w-full min-h-screen bg-gray-50 p-4 md:p-8">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-6">
          <h1 className="text-2xl md:text-3xl font-bold text-gray-800 mb-4 md:mb-0">
            Banner Management
          </h1>
          <button
            className="bg-black hover:bg-gray-800 text-white px-6 py-2 rounded-lg transition-colors duration-200"
            onClick={() => setShowAddBanner(true)}
          >
            Add New Banner
          </button>
        </div>

        <div className="bg-white rounded-xl shadow-lg overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-black text-white">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Type</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Images</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Created</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {bannerTypes.map(({ key, label }) =>
                  banners[key].map((banner, index) => (
                    <tr key={`${key}-${index}`} className="hover:bg-gray-50 transition-colors">
                      <td className="px-4 py-4 text-sm text-gray-700 font-medium">{label}</td>
                      <td className="px-4 py-4">
                        <div className="flex flex-wrap gap-2">
                          {banner.images.map((image, imgIndex) => (
                            <img
                              key={imgIndex}
                              src={image}
                              alt="Banner"
                              className="w-24 h-16 object-cover rounded-md border border-gray-200"
                            />
                          ))}
                        </div>
                      </td>
                      <td className="px-4 py-4">
                        <span
                          className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-medium ${
                            banner.isActive
                              ? "bg-green-100 text-green-800"
                              : "bg-red-100 text-red-800"
                          }`}
                        >
                          {banner.isActive ? "Active" : "Inactive"}
                        </span>
                      </td>
                      <td className="px-4 py-4 text-sm text-gray-600">
                        {new Date(banner.createdAt).toLocaleDateString("en-US", {
                          year: "numeric",
                          month: "short",
                          day: "numeric",
                        })}
                      </td>
                      <td className="px-4 py-4 text-center">
                        <button
                          onClick={() => {
                            setBannerToDelete(banner);
                            setShowConfirmDelete(true);
                          }}
                          className="text-red-500 hover:text-red-700 transition-colors p-2 rounded-lg hover:bg-red-50"
                        >
                          <MdDelete className="w-5 h-5" />
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          {bannerTypes.every(({ key }) => banners[key].length === 0) && (
            <div className="text-center py-8">
              <p className="text-gray-500">No banners found. Add your first banner!</p>
            </div>
          )}
        </div>
      </div>

      {showAddBanner && <AddBanner onClose={() => setShowAddBanner(false)} />}

      {showConfirmDelete && (
        <ConfirmDeleteModal
          onClose={() => setShowConfirmDelete(false)}
          onDelete={() => handleDeleteBanner(bannerToDelete._id, bannerToDelete.type)}
        />
      )}
    </div>
  );
};

export default Banners;